import appendQuery from 'append-query';
import urlJoin from 'url-join';
import Cookie from 'js-cookie';
import Vue from 'vue';
import axios from "axios";
import {round} from "lodash/math";

export function defaultListSegments(given) {
    return given && given.length ? given : ['all'];
}

export function defaultListColumns() {
    return ['Customer ID', 'Customer Name', 'Gender', 'Age', 'Email Address'];
}

export const CUSTOMERS_FILE_TYPE = 'customers';

export const BASE_URL =
    process.env.NODE_ENV === 'development' ?
    'https://demo-api.superfluid.io' : 'https://demo-api.superfluid.io';
// 'http://62.171.180.223:5000' : 'https://rensource-api.superscore.me';

export const doNothing = () => {};

export const fullURL = (endpoint, params = {}) => {
    return appendQuery(urlJoin(BASE_URL, endpoint), params);
};

export const parseAxiosError = e => {
    return Error(e.message);
};

export const hasAllRequiredEntities = (entities, entityMap) => {
    return entities.every(({ required, name }) => {
        return !required || (entityMap.hasOwnProperty(name) && !!entityMap[name]);
    });
};

export const JWT_TOKEN_KEY = "_ss_at_";

export function setCookie(key, value) {
    const parser = document.createElement('a');
    parser.href = window.location;
    const domain = parser.hostname.replace("app.", "");
    Cookie.set(
        key,
        value, { domain, expires: 365 }
    );
}

export function getCookie(key) {
    return Cookie.get(key);
}

export function setToken(token) {
    setCookie(JWT_TOKEN_KEY, token);
}

export function getToken() {
    return Cookie.get(JWT_TOKEN_KEY);
}

export function saveActivity(activity, activity_type, logout) {
    axios({
        method: 'post',
        url: fullURL('/user-activity'),
        data: { "activity": activity, "activity_type": activity_type },
    }).then(({ data }) => {
        console.log("activity saved", data)
        if (logout) {
            setToken("")
        }

    })
}

export function formatMapData(data) {
  let state_codes = {
    "rivers": 'ng-ri',
    "katsina": 'ng-kt',
    "sokoto": 'ng-so',
    "zamfara": 'ng-za',
    "yobe": 'ng-yo',
    "kebbi": 'ng-ke',
    "adamawa": 'ng-ad',
    "borno": 'ng-bo',
    "akwa ibom": 'ng-ak',
    'abia': 'ng-ab',
    "imo": 'ng-im',
    "bayelsa": 'ng-by',
    "benue": 'ng-be',
    "cross river": 'ng-cr',
    "taraba": 'ng-ta',
    "kwara": 'ng-kw',
    "lagos": 'ng-la',
    "niger": 'ng-ni',
    "federal capital territory": 'ng-fc',
    "ogun": 'ng-og',
    "ondo": 'ng-on',
    "ekiti": 'ng-ek',
    "osun": 'ng-os',
    "oyo": 'ng-oy',
    "anambra": 'ng-an',
    "bauchi": 'ng-ba',
    "gombe": 'ng-go',
    "delta": 'ng-de',
    "edo": 'ng-ed',
    "enugu": 'ng-en',
    "ebonyi": 'ng-eb',
    "kaduna": 'ng-kd',
    "kogi": 'ng-ko',
    "plateau": 'ng-pl',
    "nasarawa": 'ng-na',
    "jigawa": 'ng-ji',
    "kano": 'ng-kn'
  }
  data.forEach(d => {
    d[0] = state_codes[d[0].toLowerCase()]
  })

  return data
}

export function abbreviateNumber(number, precision) {
  var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
  var tier = Math.log10(number) / 3 | 0;
  if (tier == 0) {
    if (number % 1 !== 0) {
      return round(number, precision)
    }
    return number;
  }
  var suffix = SI_SYMBOL[tier];
  var scale = Math.pow(10, tier * 3);
  var scaled = number / scale;
  return scaled.toFixed(1) + suffix;
}

export function formatDateText(month_year, datatype) {
      if (datatype && datatype.toLowerCase() !== "date") {
        return month_year
      }
      let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      let month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (month_year && month_year.includes("-")) {
        let res = month_year.split("-");
        return month_names[res[1] - 1] + " " + res[2] + " " + res[0];
      }
      else if (month_year && month_year.includes("/")) {
        let res = month_year.split("/");
        return month_names_short[res[0] - 1] + " " + res[1];
      }
      return month_year
}

export function sortByMonthYearDate(a, b) {
  a = a["_id"]
  b = b["_id"]
  var as = a.split('/'),
    bs = b.split('/'),
    ad = new Date(as[0] + ' 1,' + as[1]),
    bd = new Date(bs[0] + ' 1,' + bs[1]);
  return ad.getTime() - bd.getTime();
}

export function growthType() {
  return 'count';
}

export function growthTitles() {
  const suffix = ''; // this.growthTypeIsPercentage ? ' (%)' : '';
  const name = ((growthType) => {
    switch (growthType) {
      case 'average':
        return 'Average Amount';
      case 'amount':
        return 'Amount';
      default:
        return 'Count';
    }
  })(this.growthType);

  return {
    value: `New ${name} ${suffix}`,
    aggregation: `Total ${name} ${suffix}`
  };
}

export function removeCookie(){
  const parser = document.createElement('a');

  parser.href = window.location;
  const domain = parser.hostname.replace("app.", "");
  console.log("Removing cookie....")
  return Cookie.remove(JWT_TOKEN_KEY, {domain: domain});
}

export const E_DOWNLOAD = "DOWNLOAD";
export const eventHub = new Vue();
